<template>
    <ai-subtitle value="Адресные составляющие" />
</template>

<script setup>
// import { inject } from 'vue';
import AiSubtitle from '@/components/ai-subtitle.vue';

// const data = inject('serverData');
</script>
